<div *ngIf="showBanner" class="notification-banner">
  <span class="notification-message">
    <strong>Enable desktop notifications</strong> to receive important updates.
  </span>
  <button class="notification-enable" nz-button nzType="default" (click)="enableNotifications()" [nzLoading]="isLoading">
    Enable Notifications
  </button>
  <span *ngIf="permissionStatus === 'denied'" class="notification-warning">
    You have denied notification permission. Please enable it in your browser settings.
  </span>
  <button class="notification-dismiss" nz-button nzType="text" (click)="closeBanner()">Dismiss</button>
</div>
